import { useEffect } from 'react';
import { Storage } from '../../constants/storage';

export function useRightPanelSync({
    todosProgress,
    searchSources,
    workspaceFiles,
    setHasRightPanelContent,
    isRightPanelOpen,
    isEmbedded,
}) {
    useEffect(() => {
        setHasRightPanelContent(!!(todosProgress || searchSources || workspaceFiles));
    }, [todosProgress, searchSources, workspaceFiles, setHasRightPanelContent]);

    useEffect(() => {
        if (isEmbedded) return;
        try {
            localStorage.setItem(Storage.right_panel_is_open, JSON.stringify(isRightPanelOpen));
        } catch {
            // ignore storage errors
        }
    }, [isRightPanelOpen, isEmbedded]);
}
